import React, { useEffect, useRef } from 'react';

// children, when given, render between the message and the buttons (a form
// field the confirmation carries, such as the cancel modal's return month).
function ConfirmModal({ show, title, message, confirmText = 'Confirm', cancelText = 'Cancel', confirmColor = '#1e88e5', onConfirm, onCancel, children }) {
  const confirmRef = useRef();

  useEffect(() => {
    if (show && confirmRef.current) {
      confirmRef.current.focus();
    }
  }, [show]);

  useEffect(() => {
    if (!show) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') onCancel?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [show, onCancel]);

  if (!show) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel} role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        {title && <h3 id="confirm-modal-title" className="confirm-modal-title">{title}</h3>}
        <p className="confirm-modal-message">{message}</p>
        {children}
        <div className="confirm-modal-actions">
          <button className="btn btn-outline" onClick={onCancel}>{cancelText}</button>
          <button
            ref={confirmRef}
            className="btn"
            style={{ backgroundColor: confirmColor, color: '#fff', border: 'none' }}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
      <style>{`
        .confirm-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          padding: 16px;
        }
        .confirm-modal {
          background: var(--color-surface, #fff);
          border-radius: 12px;
          padding: 24px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 20px 60px rgba(0,0,0,0.3);
        }
        .confirm-modal-title {
          margin: 0 0 8px;
          font-size: 1.1rem;
        }
        .confirm-modal-message {
          margin: 0 0 20px;
          color: var(--color-text-light, #666);
          line-height: 1.5;
        }
        .confirm-modal-actions {
          display: flex;
          gap: 8px;
          justify-content: flex-end;
        }
      `}</style>
    </div>
  );
}

function AlertModal({ show, title, message, buttonText = 'OK', onClose }) {
  useEffect(() => {
    if (!show) return;
    const handleKey = (e) => {
      if (e.key === 'Escape' || e.key === 'Enter') onClose?.();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="confirm-modal-title">{title}</h3>}
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="btn btn-primary" onClick={onClose} autoFocus>{buttonText}</button>
        </div>
      </div>
    </div>
  );
}

export { ConfirmModal, AlertModal };
export default ConfirmModal;
